export interface PainPoint {
  title: string
  paragraphs: string[]
  emphasis?: string
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 ONE SYMPTOM. TOO MANY POSSIBLE CAUSES.',
    paragraphs: [
      "The washer won't drain. The refrigerator isn't cooling. The dryer isn't heating. The dishwasher won't fill.",
      'You know the problem—but determining which component, circuit, restriction, sensor, or system is actually responsible is the difficult part.',
    ],
  },
  {
    title: '⚠️ YOU KNOW THE COMPONENTS—BUT WHAT SHOULD YOU CHECK NEXT?',
    paragraphs: [
      'You can recognize pumps, motors, switches, sensors, heating elements, valves, relays, and control boards.',
      'But diagnosing the fault requires something different: knowing what to check first, what to test next, and how to narrow down the possible causes.',
    ],
  },
  {
    title: '📚 YOUR DIAGNOSTIC RESOURCES ARE EVERYWHERE',
    paragraphs: [
      'Service manuals. Wiring diagrams. Technical notes. Videos. PDFs. Fault codes. Websites. Forums.',
      "The information exists—but it's scattered across different resources and rarely organized around fast, structured fault-finding.",
    ],
    emphasis:
      "You don't need more scattered information. You need one organized diagnostic system.",
  },
  {
    title: "😩 REPLACING MORE PARTS DOESN'T ALWAYS MEAN FIXING THE FAULT",
    paragraphs: [
      'Checking random components, searching through manuals, watching repair videos, replacing suspected parts, and trying to determine what actually caused the problem.',
      'Then the appliance still has the same fault.',
    ],
    emphasis:
      'Your diagnostic process should help you isolate the problem—not just guess which part to replace.',
  },
]
